import { hexbin } from 'd3-hexbin';
import { quadtree } from 'd3-quadtree';
import { scaleLog, scaleSequential } from 'd3-scale';
import * as scaleChromatic from 'd3-scale-chromatic';
import * as fc from 'd3fc';
import color from './webgl';
const xAccessor = (d) => d.x;
const yAccessor = (d) => d.y;
function getChromaScale(name) {
    const chroma = scaleChromatic[`interpolate${name}`];
    if (!chroma)
        throw TypeError(`No chromatic scale with name '${name}'.`);
    return chroma;
}
export default async function HexbinColor(data, chromaName = 'CubehelixDefault', radius = 1) {
    const { max, hexes } = hexbin()
        .x(xAccessor)
        .y(yAccessor)
        .radius(radius)(data)
        .reduce((acc, hex) => {
        const n = hex.length;
        if (n > acc.max)
            acc.max = n;
        acc.hexes.push({ x: hex.x, y: hex.y, n });
        return acc;
    }, { max: 0, hexes: [] });
    const hextree = quadtree().x(xAccessor).y(yAccessor).addAll(hexes);
    const scale = scaleLog().domain([1, max]);
    const chroma = scaleSequential((d) => getChromaScale(chromaName)(d));
    const magnitudeColor = (n) => color(chroma(scale(n)));
    const hexColor = (d) => { var _a, _b; return magnitudeColor((_b = (_a = hextree.find(d.x, d.y)) === null || _a === void 0 ? void 0 : _a.n) !== null && _b !== void 0 ? _b : 0); };
    return fc.webglFillColor().value(hexColor).data(data);
}
